<template>
  <v-container>
    <v-card outlined class="pa-2 mt-0" :loading="loading">
      <v-row>
        <v-col cols="12" md="12">
          <div class="text-center">
            <div class="normal16">
              สมัครเข้ารับการคัดเลือกบุคคลเพื่อบรรจุและแต่งตั้งให้ดำรงตำแหน่ง
              ศึกษานิเทศก์
            </div>
            <div class="normal14">
              สังกัดสำนักงานคณะกรรมการการอาชีวศึกษา
            </div>
          </div>
          <div class="text-center warning--text bold14">
            <div>ประจำปี {{ period_supervisor.period_sedirector_year }}</div>
            <div>
              รับสมัครระหว่างวันที่
              {{
                period_supervisor.period_sedirector_start
                  | moment("add", "543 years")
                  | moment("D MMMM YYYY")
              }}
              ถึง
              {{
                period_supervisor.period_sedirector_stop
                  | moment("add", "543 years")
                  | moment("D MMMM YYYY")
              }}
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="12">
          <v-row justify="center" no-gutters>
            <v-col md="1"></v-col>
            <v-col md="10">
              <v-stepper v-model="steps" vertical>
                <!-- ============================== -->
                <!-- Step 1: ตรวจสอบข้อมูลพื้นฐาน -->
                <!-- ============================== -->
                <v-stepper-step :complete="steps > 1" step="1" class="bold14">
                  ตรวจสอบ ข้อมูลพื้นฐาน
                </v-stepper-step>
                <v-stepper-content step="1">
                  <v-alert outlined>
                    <div class="normal14">
                      <div>
                        ชื่อ-นามสกุล :
                        <u class="bold14 pa-5">{{ users.frist_names }}</u>
                      </div>
                      <div>
                        สัญชาติ :
                        <u class="bold14 pa-5">{{
                          users.nationality || "ไทย"
                        }}</u>
                        เชื้อชาติ :
                        <u class="bold14 pa-5">{{
                          users.ethnicity || "ไทย"
                        }}</u>
                      </div>
                      <div>
                        เลขที่บัตรประจำตัวประชาชน :
                        <u class="bold14 pa-5">{{ users.id_card }}</u>
                      </div>
                      <div>
                        วันเกิด :
                        <u class="bold14 pa-5"
                          >{{ users.brith_day }} {{ users.brith_month }}
                          {{ parseInt(users.brith_year) }}</u
                        >
                      </div>
                    </div>
                    <div class="error--text font-weight-bold mt-3">
                      * เมื่อกดปุ่มดำเนินการต่อ ระบบจะทำการสร้าง
                      <u class="warning--text pa-2">ใบสมัครชั่วคราว</u>
                      ให้ทันทีในระบบ
                    </div>
                  </v-alert>
                  <v-btn color="primary" @click="addSupervisorSubmit()">
                    ดำเนินการต่อ
                  </v-btn>
                </v-stepper-content>

                <!-- ============================== -->
                <!-- Step 2: ที่อยู่ปัจจุบัน (ปรับปรุงใหม่) -->
                <!-- ============================== -->
                <v-stepper-step :complete="steps > 2" step="2">
                  ตรวจสอบ ที่อยู่ปัจจุบัน
                </v-stepper-step>
                <v-stepper-content step="2">
                  <v-card outlined class="pa-5">
                    <v-form
                      ref="form_step2"
                      v-model="formStep2Valid"
                      lazy-validation
                    >
                      <v-row>
                        <v-col cols="12" md="4">
                          <v-text-field
                            v-model="supervisor_app.supervisor_app_address"
                            label="บ้านเลขที่ *"
                            outlined
                            dense
                            :rules="rules.required"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-text-field
                            v-model="supervisor_app.supervisor_app_moo"
                            label="หมู่ที่"
                            outlined
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-text-field
                            v-model="supervisor_app.supervisor_app_soi"
                            label="ตรอก/ซอย"
                            outlined
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-text-field
                            v-model="supervisor_app.supervisor_app_road"
                            label="ถนน"
                            outlined
                            dense
                          ></v-text-field>
                        </v-col>

                        <!-- จังหวัด (Dropdown) -->
                        <v-col cols="12" md="4">
                          <v-autocomplete
                            v-model="supervisor_app.supervisor_app_province_id"
                            :items="provinces"
                            item-text="province_name"
                            item-value="province_ID"
                            label="จังหวัด *"
                            outlined
                            dense
                            :rules="rules.requiredSelect"
                            :loading="loadingProvince"
                            @change="onProvinceChange"
                            no-data-text="ไม่พบข้อมูล"
                            clearable
                          ></v-autocomplete>
                        </v-col>

                        <!-- อำเภอ (Dropdown) -->
                        <v-col cols="12" md="4">
                          <v-autocomplete
                            v-model="
                              supervisor_app.supervisor_app_prefecture_id
                            "
                            :items="prefectures"
                            item-text="prefecture_name"
                            item-value="prefecture_ID"
                            label="อำเภอ/เขต *"
                            outlined
                            dense
                            :rules="rules.requiredSelect"
                            :loading="loadingPrefecture"
                            :disabled="
                              !supervisor_app.supervisor_app_province_id
                            "
                            @change="onPrefectureChange"
                            no-data-text="กรุณาเลือกจังหวัดก่อน"
                            clearable
                          ></v-autocomplete>
                        </v-col>

                        <!-- ตำบล (Dropdown) -->
                        <v-col cols="12" md="4">
                          <v-autocomplete
                            v-model="supervisor_app.supervisor_app_district_id"
                            :items="districts"
                            item-text="district_name"
                            item-value="district_ID"
                            label="ตำบล/แขวง *"
                            outlined
                            dense
                            :rules="rules.requiredSelect"
                            :loading="loadingDistrict"
                            :disabled="
                              !supervisor_app.supervisor_app_prefecture_id
                            "
                            @change="onDistrictChange"
                            no-data-text="กรุณาเลือกอำเภอก่อน"
                            clearable
                          ></v-autocomplete>
                        </v-col>

                        <v-col cols="12" md="4">
                          <v-text-field
                            v-model="supervisor_app.supervisor_app_zipcode"
                            label="รหัสไปรษณีย์ *"
                            outlined
                            dense
                            :rules="rules.zipcode"
                            maxlength="5"
                            counter="5"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-text-field
                            v-model="supervisor_app.supervisor_app_phone"
                            label="โทรศัพท์มือถือ *"
                            outlined
                            dense
                            :rules="rules.phone"
                            maxlength="10"
                            counter="10"
                            placeholder="0812345678"
                          ></v-text-field>
                        </v-col>

                        <!-- ===== ข้อมูลบัตรประชาชน (เพิ่มใหม่) ===== -->
                        <v-col cols="12">
                          <v-divider class="mb-3"></v-divider>
                          <div class="bold14 primary--text mb-2">
                            ข้อมูลบัตรประจำตัวประชาชน
                          </div>
                        </v-col>

                        <v-col cols="12" md="4">
                          <v-menu
                            v-model="menuCardIssueDate"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="
                                  supervisor_app.supervisor_app_card_issue_date
                                "
                                label="วันที่ออกบัตร *"
                                prepend-icon="mdi-calendar"
                                readonly
                                outlined
                                dense
                                :rules="rules.required"
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="
                                supervisor_app.supervisor_app_card_issue_date
                              "
                              @input="menuCardIssueDate = false"
                              locale="th"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" md="4">
                          <v-menu
                            v-model="menuCardExpireDate"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="
                                  supervisor_app.supervisor_app_card_expire_date
                                "
                                label="วันหมดอายุ *"
                                prepend-icon="mdi-calendar"
                                readonly
                                outlined
                                dense
                                :rules="rules.required"
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="
                                supervisor_app.supervisor_app_card_expire_date
                              "
                              @input="menuCardExpireDate = false"
                              locale="th"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" md="4">
                          <v-autocomplete
                            v-model="
                              supervisor_app.supervisor_app_card_province_id
                            "
                            :items="provinces"
                            item-text="province_name"
                            item-value="province_ID"
                            label="ออกให้ ณ จังหวัด *"
                            outlined
                            dense
                            :rules="rules.requiredSelect"
                            :loading="loadingProvince"
                            @change="onCardProvinceChange"
                            no-data-text="ไม่พบข้อมูล"
                            clearable
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card>
                  <v-btn
                    color="primary"
                    class="mt-3"
                    @click="validateAndSubmitStep2()"
                  >
                    ดำเนินการต่อ
                  </v-btn>
                  <v-btn
                    outlined
                    class="mt-3"
                    @click="deleteSupervisorSubmit()"
                  >
                    ยกเลิกขั้นตอนนี้
                  </v-btn>
                </v-stepper-content>

                <!-- ============================== -->
                <!-- Step 3: คุณวุฒิการศึกษา -->
                <!-- ============================== -->
                <v-stepper-step :complete="steps > 3" step="3">
                  ตรวจสอบ คุณวุฒิการศึกษา
                </v-stepper-step>
                <v-stepper-content step="3">
                  <v-card outlined>
                    <v-simple-table class="normal14">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">ระดับการศึกษา</th>
                            <th class="text-left">ชื่อวุฒิ/สาขาวิชา</th>
                            <th class="text-left">สถาบันการศึกษา</th>
                            <th class="text-left">วันที่จบ</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in personnel_educations"
                            :key="item.id"
                          >
                            <td>{{ item.education_level }}</td>
                            <td>
                              {{ item.faculty_name }} : {{ item.branch_name }}
                            </td>
                            <td>{{ item.academy_name }}</td>
                            <td>{{ item.graduate_date }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                  <v-btn
                    color="primary"
                    class="mt-3"
                    @click="supervisorAppSubmit(3)"
                  >
                    ดำเนินการต่อ
                  </v-btn>
                  <v-btn outlined class="mt-3" @click="supervisorAppSubmit(1)">
                    ยกเลิกขั้นตอนนี้
                  </v-btn>
                </v-stepper-content>

                <!-- ============================== -->
                <!-- Step 4: ตำแหน่งปัจจุบัน -->
                <!-- ============================== -->
                <v-stepper-step :complete="steps > 4" step="4">
                  ตรวจสอบ ตำแหน่งปัจจุบัน / การดำรงตำแหน่ง
                </v-stepper-step>
                <v-stepper-content step="4">
                  <v-alert outlined>
                    <div class="normal14">
                      <div>
                        ปัจจุบันดำรงตำแหน่ง :
                        <u class="bold14 pa-5">{{ users.position_name }}</u>
                      </div>
                      <div>
                        วิทยฐานะ :
                        <u class="bold14 pa-5">{{ users.rang_name }}</u>
                        อันดับ ค.ศ. :
                        <u class="bold14 pa-5">{{ users.rang_level }}</u>
                      </div>
                      <div>
                        เงินเดือน :
                        <u class="bold14 pa-5">{{ users.salary_s }}</u> บาท
                      </div>
                      <div>
                        สถานศึกษา/หน่วยงาน :
                        <u class="bold14 pa-5">{{ users.college_name }}</u>
                      </div>
                      <div>{{ users.collegeinfo_address }}</div>
                      <div>
                        ดำรงตำแหน่งปัจจุบันเมื่อวันที่ :
                        <u class="bold14 pa-5">
                          {{
                            users.date_app_positonnow
                              | moment("add", "543 years")
                              | moment("D MMMM YYYY")
                          }}
                        </u>
                      </div>
                      <div>
                        รวมระยะเวลาที่ดำรงตำแหน่งปัจจุบัน :
                        <u class="bold14 pa-5">{{ get_Appoint_Age }}</u>
                      </div>
                    </div>

                    <!-- ===== ข้อมูลใบอนุญาตประกอบวิชาชีพศึกษานิเทศก์ (เพิ่มใหม่) ===== -->
                    <v-divider class="my-3"></v-divider>
                    <div class="normal14">
                      <h4 class="primary--text">
                        <v-icon color="primary" small class="mr-1"
                          >mdi-certificate</v-icon
                        >
                        ข้อมูลใบอนุญาตประกอบวิชาชีพศึกษานิเทศก์
                      </h4>
                      <div>
                        เลขที่ใบอนุญาต :
                        <u class="bold14 pa-5">{{
                          users.pt_licence_sp || "-"
                        }}</u>
                      </div>
                      <div>
                        วันที่ออกใบอนุญาต :
                        <u class="bold14 pa-5">
                          <span v-if="users.pt_ondate_sp">
                            {{
                              users.pt_ondate_sp
                                | moment("add", "543 years")
                                | moment("D MMMM YYYY")
                            }}
                          </span>
                          <span v-else>-</span>
                        </u>
                      </div>
                      <div>
                        วันหมดอายุ :
                        <u class="bold14 pa-5">
                          <span v-if="users.pt_enddate_sp">
                            {{
                              users.pt_enddate_sp
                                | moment("add", "543 years")
                                | moment("D MMMM YYYY")
                            }}
                          </span>
                          <span v-else>-</span>
                        </u>
                      </div>
                    </div>

                    <v-divider class="my-3"></v-divider>

                    <div class="normal14">
                      <h4>กรณีที่ไม่ได้ดำรงตำแหน่งครูชำนาญการในปัจจุบัน</h4>
                      <v-radio-group
                        v-model="
                          supervisor_app.supervisor_app_prev_position_type
                        "
                      >
                        <v-radio value="current">
                          <template v-slot:label>
                            <strong class="primary--text"
                              >ปัจจุบันดำรงตำแหน่งครู
                              มีวิทยฐานะไม่ต่ำกว่าครูชำนาญการ</strong
                            >
                          </template>
                        </v-radio>
                        <v-radio value="previous">
                          <template v-slot:label>
                            <strong class="warning--text"
                              >เคยดำรงตำแหน่งครูชำนาญการ
                              (แต่ปัจจุบันดำรงตำแหน่งอื่น)</strong
                            >
                          </template>
                        </v-radio>
                      </v-radio-group>

                      <div
                        v-if="
                          supervisor_app.supervisor_app_prev_position_type ===
                            'previous'
                        "
                        class="ml-8"
                      >
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-menu
                              v-model="menuPrevStart"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="
                                    supervisor_app.supervisor_app_prev_start
                                  "
                                  label="เคยดำรงตำแหน่งตั้งแต่วันที่"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  outlined
                                  dense
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="
                                  supervisor_app.supervisor_app_prev_start
                                "
                                @input="menuPrevStart = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-menu
                              v-model="menuPrevEnd"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="
                                    supervisor_app.supervisor_app_prev_end
                                  "
                                  label="ถึงวันที่"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  outlined
                                  dense
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="supervisor_app.supervisor_app_prev_end"
                                @input="menuPrevEnd = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="4">
                            <div class="pt-2 normal14">
                              รวมระยะเวลา : {{ get_PrevPosition_Age }}
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </v-alert>

                  <v-btn
                    color="primary"
                    class="mt-3"
                    @click="supervisorAppSubmit(4)"
                  >
                    ดำเนินการต่อ
                  </v-btn>
                  <v-btn outlined class="mt-3" @click="supervisorAppSubmit(2)">
                    ยกเลิกขั้นตอนนี้
                  </v-btn>
                </v-stepper-content>

                <!-- ============================== -->
                <!-- Step 5: สถานที่ติดต่อ -->
                <!-- ============================== -->
                <v-stepper-step :complete="steps > 5" step="5">
                  สถานที่ติดต่อ / ข้อมูลติดต่อ
                </v-stepper-step>
                <v-stepper-content step="5">
                  <v-card outlined class="pa-5">
                    <v-form
                      ref="form_step5"
                      v-model="formStep5Valid"
                      lazy-validation
                    >
                      <v-row>
                        <v-col cols="12" md="12">
                          <v-text-field
                            v-model="
                              supervisor_app.supervisor_app_contact_address
                            "
                            label="สถานที่ติดต่อได้สะดวก *"
                            outlined
                            dense
                            :rules="rules.required"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-text-field
                            v-model="supervisor_app.supervisor_app_tel_office"
                            label="โทรศัพท์ที่ทำงาน"
                            outlined
                            dense
                            :rules="rules.phoneOptional"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-text-field
                            v-model="supervisor_app.supervisor_app_tel_home"
                            label="โทรศัพท์บ้าน"
                            outlined
                            dense
                            :rules="rules.phoneOptional"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-text-field
                            v-model="supervisor_app.supervisor_app_tel_mobile"
                            label="โทรศัพท์มือถือ *"
                            outlined
                            dense
                            :rules="rules.phone"
                            maxlength="10"
                            counter="10"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="supervisor_app.supervisor_app_email"
                            label="E-mail *"
                            outlined
                            dense
                            :rules="rules.email"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card>
                  <v-btn
                    color="primary"
                    class="mt-3"
                    @click="validateAndSubmitStep5()"
                  >
                    ดำเนินการต่อ
                  </v-btn>
                  <v-btn outlined class="mt-3" @click="supervisorAppSubmit(3)">
                    ย้อนกลับ
                  </v-btn>
                </v-stepper-content>

                <!-- ============================== -->
                <!-- Step 6: การรักษาวินัย -->
                <!-- ============================== -->
                <v-stepper-step :complete="steps > 6" step="6">
                  ข้อมูล การรักษาวินัย
                </v-stepper-step>
                <v-stepper-content step="6">
                  <v-card outlined class="pa-5">
                    <v-radio-group
                      v-model="supervisor_app.supervisor_app_discipline"
                      :rules="rules.requiredSelect"
                    >
                      <v-radio value="ever">
                        <template v-slot:label>
                          <strong class="warning--text"
                            >เคยถูกลงโทษทางวินัย</strong
                          >
                        </template>
                      </v-radio>
                      <v-radio value="never">
                        <template v-slot:label>
                          <strong class="primary--text"
                            >ไม่เคยถูกลงโทษทางวินัย</strong
                          >
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-card>
                  <v-btn
                    color="primary"
                    class="mt-3"
                    v-if="supervisor_app.supervisor_app_discipline"
                    @click="supervisorAppSubmit(6)"
                  >
                    ดำเนินการต่อ
                  </v-btn>
                  <v-btn outlined class="mt-3" @click="supervisorAppSubmit(4)">
                    ย้อนกลับ
                  </v-btn>
                </v-stepper-content>

                <!-- ============================== -->
                <!-- Step 7: พิมพ์ใบสมัคร / หลักฐาน -->
                <!-- ============================== -->
                <v-stepper-step :complete="steps > 7" step="7">
                  พิมพ์ใบสมัคร / หลักฐานที่แนบมาพร้อมใบสมัคร
                </v-stepper-step>
                <v-stepper-content step="7">
                  <v-card
                    outlined
                    class="pa-5 mb-4"
                    style="background-color: #f5f5f5; border-color: #e4e4e7;"
                  >
                    <h3 class="mb-4 font-weight-medium primary--text">
                      <v-icon color="primary" class="mr-2"
                        >mdi-checkbox-marked-outline</v-icon
                      >
                      กรุณาทำเครื่องหมายถูก (✓)
                      ในรายการหลักฐานที่ท่านมีและจะแนบไปพร้อมกับใบสมัคร
                    </h3>

                    <v-form ref="form_step7" lazy-validation>
                      <v-row>
                        <v-col
                          cols="12"
                          class="py-1"
                          v-for="doc in documentList"
                          :key="doc.field"
                        >
                          <v-checkbox
                            v-model="supervisor_app[doc.field]"
                            true-value="1"
                            false-value="0"
                            hide-details="auto"
                            class="mt-0"
                            color="success"
                            @change="autoSaveChecklist"
                          >
                            <template v-slot:label>
                              <span
                                class="normal14"
                                :class="{
                                  'font-weight-bold grey--text text--darken-3':
                                    doc.required
                                }"
                              >
                                {{ doc.number }} {{ doc.label }}
                                <span v-if="doc.required" class="error--text"
                                  >*</span
                                >
                              </span>
                            </template>
                          </v-checkbox>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card>

                  <v-alert
                    type="warning"
                    border="left"
                    class="mt-5 pa-4 normal14"
                    colored-border
                    elevation="2"
                    style="background: #fff4dc; color: #a86400; border-left-width: 6px;"
                  >
                    <div style="line-height: 1.6;">
                      <strong>หมายเหตุ:</strong>
                      ท่านต้องทำเครื่องหมายในรายการที่บังคับ (ที่มีเครื่องหมาย
                      <span class="error--text">*</span>) ให้ครบถ้วน จึงจะสามารถ
                      <b>พิมพ์ใบสมัคร</b> และ <b>ยืนยันการสมัคร</b> ได้
                    </div>
                  </v-alert>

                  <div class="text-center mt-6">
                    <v-btn
                      color="info"
                      :disabled="!allRequiredFilesChecked"
                      class="mr-3 px-6"
                      @click="
                        openPrintDialog(supervisor_app.supervisor_app_idref)
                      "
                    >
                      <v-icon left>mdi-printer</v-icon> พิมพ์ใบสมัคร
                    </v-btn>

                    <v-btn
                      color="primary"
                      :disabled="!allRequiredFilesChecked"
                      class="px-6"
                      @click="confirmSupervisorAppSubmit()"
                    >
                      <v-icon left>mdi-check-circle</v-icon> ยืนยันการสมัคร
                    </v-btn>
                  </div>

                  <div class="text-center mt-4">
                    <p class="error--text normal14 font-weight-bold mb-0">
                      * พิมพ์ใบสมัคร เสนอผู้บังคับบัญชาชั้นต้นพิจารณาลงนาม
                    </p>
                    <p class="error--text normal14">
                      * เมื่อกดยืนยันการสมัครแล้ว จะไม่สามารถแก้ไขข้อมูลได้อีก
                    </p>
                  </div>

                  <v-btn outlined class="mt-3" @click="supervisorAppSubmit(5)">
                    กลับไปขั้นตอนก่อนหน้า
                  </v-btn>
                </v-stepper-content>

                <!-- ============================== -->
                <!-- Step 8: สถานะการดำเนินการ -->
                <!-- ============================== -->
                <v-stepper-step :complete="steps > 8" step="8">
                  สถานะการดำเนินการ
                </v-stepper-step>
                <v-stepper-content step="8">
                  <v-card outlined class="mb-5 pa-5">
                    <div class="text-center">
                      <v-timeline :dense="$vuetify.breakpoint.smAndDown">
                        <v-timeline-item color="error lighten-2" fill-dot left>
                          <v-card>
                            <v-card-title class="error lighten-2">
                              <div class="white--text font-weight-light">
                                <v-icon dark size="20"
                                  >mdi-text-box-check-outline</v-icon
                                >
                                หลักฐานที่แนบของผู้สมัคร
                              </div>
                            </v-card-title>
                            <v-container>
                              <v-simple-table>
                                <thead>
                                  <tr>
                                    <th class="text-left">รายการ</th>
                                    <th class="text-center" style="width: 20%">
                                      สถานะแจ้งไว้
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="doc in documentList"
                                    :key="'status_' + doc.field"
                                  >
                                    <td class="text-left normal14">
                                      {{ doc.label }}
                                    </td>
                                    <td class="text-center">
                                      <v-icon
                                        v-if="supervisor_app[doc.field] === '1' || supervisor_app[doc.field] === 1"
                                        color="success"
                                        >mdi-check-circle</v-icon
                                      >
                                      <span
                                        v-else
                                        class="grey--text normal14"
                                        >{{
                                          doc.required ? "ไม่ได้เลือก" : "-"
                                        }}</span
                                      >
                                    </td>
                                  </tr>
                                </tbody>
                              </v-simple-table>
                            </v-container>
                          </v-card>
                        </v-timeline-item>

                        <v-timeline-item color="error lighten-2" fill-dot right>
                          <v-card>
                            <v-card-title class="error lighten-2">
                              <div class="white--text font-weight-light">
                                <v-icon dark size="20">mdi-magnify</v-icon>
                                ประกาศรายชื่อผู้มีสิทธิเข้ารับการคัดเลือก
                              </div>
                            </v-card-title>
                            <v-container>
                              <div
                                v-if="
                                  supervisor_app.supervisor_app_approve ===
                                    'pass' || supervisor_app.supervisor_app_approve === 1
                                "
                                class="success--text font-weight-bold"
                              >
                                ผ่านคุณสมบัติผู้สมัคร
                              </div>
                              <div
                                v-else-if="
                                  supervisor_app.supervisor_app_approve ===
                                    'fail' || supervisor_app.supervisor_app_approve === 0
                                "
                                class="error--text font-weight-bold"
                              >
                                ไม่ผ่านคุณสมบัติ
                              </div>
                              <div v-else>รอการประกาศรายชื่อ</div>
                            </v-container>
                          </v-card>
                        </v-timeline-item>

                        <v-timeline-item
                          color="warning lighten-1"
                          fill-dot
                          left
                          small
                        >
                          <v-card>
                            <v-card-title class="warning lighten-1 justify-end">
                              <div class="mr-4 white--text font-weight-light">
                                หน่วยรับสมัคร / สถานศึกษาต้นสังกัด
                              </div>
                            </v-card-title>
                            <v-container>
                              ตรวจสอบคุณสมบัติและหลักฐานผู้สมัคร
                            </v-container>
                          </v-card>
                        </v-timeline-item>

                        <v-timeline-item color="info lighten-1" fill-dot right>
                          <v-card>
                            <v-card-title class="info lighten-1">
                              <h2 class="white--text font-weight-light">
                                ส่วนกลาง สอศ.
                              </h2>
                            </v-card-title>
                            <v-container>
                              ประกาศรายชื่อผู้มีสิทธิเข้ารับการคัดเลือก ภาค ก
                              ภาค ข และ ภาค ค
                            </v-container>
                          </v-card>
                        </v-timeline-item>

                        <v-timeline-item color="success lighten-1" fill-dot right>
                          <v-card>
                            <v-card-title class="success lighten-1">
                              <h2 class="white--text font-weight-light">
                                ส่วนกลาง สอศ.
                              </h2>
                            </v-card-title>
                            <v-container>
                              ประกาศรายชื่อผู้ผ่านการคัดเลือก / บรรจุแต่งตั้ง
                            </v-container>
                          </v-card>
                        </v-timeline-item>
                      </v-timeline>
                    </div>

                    <!-- ============================== -->
                    <!-- ประวัติ Log กิจกรรม -->
                    <!-- ============================== -->
                    <v-divider class="my-4"></v-divider>
                    <h4 class="mb-3">
                      <v-icon class="mr-1">mdi-history</v-icon>
                      ประวัติกิจกรรมการสมัคร
                    </h4>
                    <v-simple-table v-if="appLogs.length > 0" dense>
                      <thead>
                        <tr>
                          <th>วันเวลา</th>
                          <th>กิจกรรม</th>
                          <th>ขั้นตอน</th>
                          <th>หมายเหตุ</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="log in appLogs" :key="log.log_id">
                          <td class="normal14">
                            {{ formatLogDate(log.log_created_at) }}
                          </td>
                          <td>
                            <v-chip
                              small
                              :color="getLogColor(log.log_action)"
                              dark
                              >{{ getLogLabel(log.log_action) }}</v-chip
                            >
                          </td>
                          <td class="normal14">
                            <span v-if="log.log_step_from !== null">
                              {{ log.log_step_from }} → {{ log.log_step_to }}
                            </span>
                            <span v-else>-</span>
                          </td>
                          <td class="normal14">{{ log.log_note || "-" }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                    <div v-else class="text-center grey--text pa-3">
                      ยังไม่มีประวัติกิจกรรม
                    </div>
                  </v-card>
                </v-stepper-content>
              </v-stepper>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

 
      <!-- ปุ่มยกเลิก -->
      <div class="text-center mt-4">
         <v-btn
          color="info"
          :disabled="!allRequiredFilesChecked"
          @click="openPrintDialog(supervisor_app.supervisor_app_idref)"
        >
          <v-icon left>mdi-printer</v-icon> พิมพ์ใบสมัคร
        </v-btn> 
      
        <v-btn color="warning" dark @click="dialog = true">
          <v-icon left>mdi-close</v-icon>
          ยกเลิกรายการ
        </v-btn>
        <br />
        <span class="error--text font-weight-bold">
          * กรณีที่ต้องการยกเลิกการสมัคร ให้กดปุ่มยกเลิกนี้ <br />
          ระบบจะทำการลบใบสมัครชั่วคราวและข้อมูลที่กรอกไปแล้วทั้งหมดออกจากระบบทันที
          <br />
          และสามารถทำรายการใหม่อีกครั้งได้ภายในเวลากำหนด
        </span>
      </div>

      <!-- Dialog ยืนยันยกเลิก -->
      <v-dialog v-model="dialog" max-width="500">
        <v-card>
          <v-card-title class="headline error--text">
            ยืนยันการยกเลิก
          </v-card-title>
          <v-card-text>
            คุณต้องการยกเลิกใบสมัครนี้ใช่หรือไม่?
            ข้อมูลทั้งหมดจะถูกลบออกจากระบบทันที
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialog = false"> ยกเลิก </v-btn>
            <v-btn color="error" dark @click="confirmCancel"> ยืนยันลบ </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>

    <!-- Dialog พิมพ์ใบสมัคร -->
    <v-dialog v-model="printAppDialog" max-width="1000px" scrollable>
      <v-card>
        <v-card-title class="white--text primary pa-4 d-flex align-center">
          <v-icon color="white" class="mr-2">mdi-printer</v-icon>
          <span class="font-weight-medium text-h6"
            >ตัวอย่างใบสมัครศึกษานิเทศก์</span
          >
          <v-spacer></v-spacer>
          <v-btn icon color="white" @click="printAppDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0" style="height: 80vh; overflow: hidden;">
          <iframe
            v-if="pdfAppSrc"
            :src="pdfAppSrc"
            width="100%"
            height="100%"
            style="border: none;"
          ></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "HRvecSupervisorApp",

  data() {
    return {
      ApiKey: "HRvec2021",
      loading: false,
      steps: 1,
      menuPrevStart: false,
      menuPrevEnd: false,
      menuCardIssueDate: false,
      menuCardExpireDate: false,

      // Form validation state
      formStep2Valid: true,
      formStep5Valid: true,

      // Data
      users: [],
      personnel_educations: [],
      period_supervisor: [],
      supervisor_app: {},
      addSupervisor: {},
      appLogs: [],

      // Province / Prefecture / District data
      provinces: [],
      prefectures: [],
      districts: [],
      loadingProvince: false,
      loadingPrefecture: false,
      loadingDistrict: false,

      // Validation Rules
      rules: {
        required: [v => !!v || "กรุณากรอกข้อมูล"],
        requiredSelect: [v => !!v || "กรุณาเลือกข้อมูล"],
        phone: [
          v => !!v || "กรุณากรอกเบอร์โทรศัพท์",
          v =>
            /^[0-9]{9,10}$/.test(v) || "เบอร์โทรศัพท์ต้องเป็นตัวเลข 9-10 หลัก"
        ],
        phoneOptional: [
          v =>
            !v ||
            /^[0-9]{9,10}$/.test(v) ||
            "เบอร์โทรศัพท์ต้องเป็นตัวเลข 9-10 หลัก"
        ],
        zipcode: [
          v => !!v || "กรุณากรอกรหัสไปรษณีย์",
          v => /^[0-9]{5}$/.test(v) || "รหัสไปรษณีย์ต้องเป็นตัวเลข 5 หลัก"
        ],
        email: [
          v => !!v || "กรุณากรอก E-mail",
          v => /.+@.+\..+/.test(v) || "รูปแบบ E-mail ไม่ถูกต้อง"
        ]
      },

      // รายการหลักฐาน
      documentList: [
        {
          number: "6.1",
          field: "supervisor_app_file_1",
          label: "สำเนาปริญญาบัตรหรือหนังสือรับรองวุฒิการศึกษา",
          required: true
        },
        {
          number: "6.2",
          field: "supervisor_app_file_2",
          label: "สำเนาระเบียนแสดงผลการเรียน (Transcript)",
          required: true
        },
        {
          number: "6.3",
          field: "supervisor_app_file_3",
          label: "สำเนาทะเบียนประวัติข้าราชการ (ก.พ.7/ก.ค.ศ.16)",
          required: true
        },
        {
          number: "6.4",
          field: "supervisor_app_file_4",
          label: "สำเนาทะเบียนบ้าน",
          required: true
        },
        {
          number: "6.5",
          field: "supervisor_app_file_5",
          label: "สำเนาบัตรข้าราชการ",
          required: true
        },
        {
          number: "6.6",
          field: "supervisor_app_file_6",
          label: "สำเนาบัตรประจำตัวประชาชน",
          required: true
        },
        {
          number: "6.7",
          field: "supervisor_app_file_7",
          label: "รูปถ่ายหน้าตรง ขนาด 1 นิ้ว (ติดที่ใบสมัคร)",
          required: true
        },
        {
          number: "6.8",
          field: "supervisor_app_file_8",
          label: "สำเนาใบอนุญาตประกอบวิชาชีพศึกษานิเทศก์",
          required: true
        },
        {
          number: "6.9",
          field: "supervisor_app_file_9",
          label: "แบบเสนอชื่อผู้มีความรู้ความสามารถเหมาะสม (ถ้ามี)",
          required: false
        },
        {
          number: "6.10",
          field: "supervisor_app_file_10",
          label:
            "ประวัติและประสบการณ์การเป็นผู้นำทางวิชาการ (ไม่เกิน 5 หน้า A4)",
          required: true
        },
        {
          number: "6.11",
          field: "supervisor_app_file_11",
          label: "วิสัยทัศน์การเป็นศึกษานิเทศก์ (ไม่เกิน 2 หน้า A4)",
          required: true
        },
        {
          number: "6.12",
          field: "supervisor_app_file_12",
          label:
            "ผลงานหรือรางวัลที่เกี่ยวกับการจัดการเรียนการสอน (ไม่เกิน 2 หน้า A4)",
          required: true
        },
        {
          number: "6.13",
          field: "supervisor_app_file_13",
          label: "แผนการนิเทศเพื่อประเมินความสามารถในการนิเทศการศึกษา",
          required: true
        },
        {
          number: "6.14",
          field: "supervisor_app_file_14",
          label: "หลักฐานอื่นๆ (ถ้ามี)",
          required: false
        }
      ],

      printAppDialog: false,
      pdfAppSrc: "",
      dialog: false
    };
  },

  async mounted() {
    await this.periodSupervisorQuery();
    await this.personnelTemporaryQuery();
    await this.personnelEducationsQueryAll();
    await this.supervisorAppQuery();
    await this.provinceQuery();
    await this.loadSavedAddress();
  },

  methods: {
    // ============================
    // Province / Prefecture / District
    // ============================
    async provinceQuery() {
      this.loadingProvince = true;
      try {
        let result = await this.$http.post("province.php", {});
        this.provinces = result.data || [];
      } catch (e) {
        console.error("Province query error:", e);
      } finally {
        this.loadingProvince = false;
      }
    },

    async onProvinceChange(provinceId) {
      this.supervisor_app.supervisor_app_prefecture_id = null;
      this.supervisor_app.supervisor_app_district_id = null;
      this.prefectures = [];
      this.districts = [];

      const prov = this.provinces.find(p => p.province_ID == provinceId);
      if (prov) {
        this.supervisor_app.supervisor_app_province = prov.province_name;
      }

      if (provinceId) {
        await this.prefectureQuery(provinceId);
      }
    },

    async prefectureQuery(provinceId) {
      this.loadingPrefecture = true;
      try {
        let result = await this.$http.post("prefecture.php", {
          province_ID: provinceId
        });
        this.prefectures = result.data || [];
      } catch (e) {
        console.error("Prefecture query error:", e);
      } finally {
        this.loadingPrefecture = false;
      }
    },

    async onPrefectureChange(prefectureId) {
      this.supervisor_app.supervisor_app_district_id = null;
      this.districts = [];

      const pref = this.prefectures.find(p => p.prefecture_ID == prefectureId);
      if (pref) {
        this.supervisor_app.supervisor_app_district = pref.prefecture_name;
      }

      if (prefectureId) {
        await this.districtQuery(prefectureId);
      }
    },

    async districtQuery(prefectureId) {
      this.loadingDistrict = true;
      try {
        let result = await this.$http.post("districts.php", {
          prefecture_ID: prefectureId
        });
        this.districts = result.data || [];
      } catch (e) {
        console.error("District query error:", e);
      } finally {
        this.loadingDistrict = false;
      }
    },

    onDistrictChange(districtId) {
      const dist = this.districts.find(d => d.district_ID == districtId);
      if (dist) {
        this.supervisor_app.supervisor_app_subdistrict = dist.district_name;
        if (dist.district_zipcode) {
          this.supervisor_app.supervisor_app_zipcode = dist.district_zipcode;
        }
      }
    },

    // ============================
    // บัตรประชาชน - ออกให้ ณ จังหวัด (เพิ่มใหม่)
    // ============================
    onCardProvinceChange(provinceId) {
      const prov = this.provinces.find(p => p.province_ID == provinceId);
      if (prov) {
        this.supervisor_app.supervisor_app_card_province = prov.province_name;
      }
    },

    async loadSavedAddress() {
      if (this.supervisor_app.supervisor_app_province_id) {
        await this.prefectureQuery(
          this.supervisor_app.supervisor_app_province_id
        );
      }
      if (this.supervisor_app.supervisor_app_prefecture_id) {
        await this.districtQuery(
          this.supervisor_app.supervisor_app_prefecture_id
        );
      }
    },

    // ============================
    // Validation + Submit
    // ============================
    async validateAndSubmitStep2() {
      const valid = this.$refs.form_step2.validate();
      if (!valid) {
        Swal.fire({
          icon: "warning",
          title: "กรุณากรอกข้อมูลที่จำเป็นให้ครบถ้วน",
          html: "ตรวจสอบฟิลด์ที่มีเครื่องหมาย * ให้ครบ",
          showConfirmButton: true
        });
        return;
      }
      await this.supervisorAppSubmit(2);
    },

    async validateAndSubmitStep5() {
      const valid = this.$refs.form_step5.validate();
      if (!valid) {
        Swal.fire({
          icon: "warning",
          title: "กรุณากรอกข้อมูลที่จำเป็นให้ครบถ้วน",
          html: "ตรวจสอบฟิลด์ที่มีเครื่องหมาย * ให้ครบ",
          showConfirmButton: true
        });
        return;
      }
      await this.supervisorAppSubmit(5);
    },

    // ============================
    // Log Methods
    // ============================
    async fetchAppLogs() {
      try {
        let result = await this.$http.post("supervisor_app_log.php", {
          ApiKey: this.ApiKey,
          supervisor_app_idref: this.supervisor_app_idref,
          limit: 50
        });
        this.appLogs = result.data || [];
      } catch (e) {
        console.error("Log fetch error:", e);
      }
    },

    formatLogDate(dateStr) {
      if (!dateStr) return "-";
      const d = new Date(dateStr);
      return d.toLocaleString("th-TH", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });
    },

    getLogColor(action) {
      const colors = {
        create: "blue",
        update: "teal",
        step_change: "primary",
        checklist_update: "cyan",
        confirm: "green",
        delete: "red",
        print: "primary"
      };
      return colors[action] || "grey";
    },

    getLogLabel(action) {
      const labels = {
        create: "สร้างใบสมัคร",
        update: "แก้ไขข้อมูล",
        step_change: "เปลี่ยนขั้นตอน",
        checklist_update: "อัปเดตหลักฐาน",
        confirm: "ยืนยันการสมัคร",
        delete: "ยกเลิกใบสมัคร",
        print: "พิมพ์ใบสมัคร"
      };
      return labels[action] || action;
    },

    // ============================
    // Existing Methods (ปรับปรุง)
    // ============================
    confirmCancel() {
      this.supervisor_app.ApiKey = this.ApiKey;
      this.supervisor_app.supervisor_app_idref = this.supervisor_app_idref;
      this.deleteSupervisorSubmit();
      this.dialog = false;
    },

    openPrintDialog(idref) {
      let baseURL = this.$http.defaults.baseURL || "";
      this.pdfAppSrc = `${baseURL}print_app_supervisor.php?id=${idref}`;

      this.$http
        .post("supervisor_app_log_insert.php", {
          ApiKey: this.ApiKey,
          supervisor_app_idref: idref,
          supervisor_app_idcard: this.users.id_card,
          log_action: "print",
          log_note: "พิมพ์ใบสมัครศึกษานิเทศก์"
        })
        .catch(e => console.error("Print log error:", e));

      this.printAppDialog = true;
    },

    async personnelTemporaryQuery() {
      let userSession = JSON.parse(localStorage.getItem("user")) || 0;
      let result = await this.$http.post("personnel_temporary_new.php", {
        ApiKey: this.ApiKey,
        id_card: userSession.id_card
      });
      this.users = result.data;

      let pt_licence_supervisor = String(this.users.pt_licencedr_sp_file || "");
      if (pt_licence_supervisor.length < 10) {
        Swal.fire({
          icon: "error",
          title:
            "ไม่ปรากฎใบอนุญาตประกอบวิชาชีพศึกษานิเทศก์ กรุณาปรับปรุงข้อมูลใบอนุญาต",
          allowOutsideClick: false,
          allowEscapeKey: false
        }).then(async result => {
          if (result.isConfirmed) {
            this.$router.push("/UserProfile");
          }
        });
      }

      let level_rang = parseInt(this.users.rang_level);
      if (level_rang < 2 || level_rang > 5) {
        Swal.fire({
          icon: "error",
          title: "ท่านขาดคุณสมบัติในการสมัคร (วิทยฐานะไม่ต่ำกว่าครูชำนาญการ)",
          allowOutsideClick: false,
          allowEscapeKey: false
        }).then(async result => {
          if (result.isConfirmed) {
            this.$router.push("/UserProfile");
          }
        });
      }
    },

    async periodSupervisorQuery() {
      let result = await this.$http.post("period_sedirector.php", {
        ApiKey: this.ApiKey,
        period_sedirector_enable: "1",
        period_sedirector_id: "402"
      });
      this.period_supervisor = result.data;
    },

    async personnelEducationsQueryAll() {
      this.loading = true;
      let userSession = JSON.parse(localStorage.getItem("user")) || 0;
      let result = await this.$http
        .post("personnel_education.php", {
          ApiKey: this.ApiKey,
          id_card: userSession.id_card
        })
        .finally(() => (this.loading = false));
      this.personnel_educations = result.data;

      if (!this.personnel_educations || this.personnel_educations.length < 1) {
        Swal.fire({
          icon: "error",
          title: "ไม่พบรายการวุฒิการศึกษา กรุณากรอกข้อมูลวุฒิการศึกษา",
          allowOutsideClick: false,
          allowEscapeKey: false
        }).then(async result => {
          if (result.isConfirmed) {
            this.$router.push("/personnel_education");
          }
        });
      }
    },

    async supervisorAppQuery() {
      let result = await this.$http.post("supervisor_app.php", {
        ApiKey: this.ApiKey,
        supervisor_app_idref: this.supervisor_app_idref
      });
      this.supervisor_app = result.data || {};
      if (this.supervisor_app.supervisor_app_status >= 1) {
        this.steps = parseInt(this.supervisor_app.supervisor_app_status) + 1;
      } else {
        this.steps = 1;
      }

      if (this.supervisor_app.supervisor_app_idref) {
        await this.fetchAppLogs();
      }
    },

    async addSupervisorSubmit() {
      this.addSupervisor.ApiKey = this.ApiKey;
      this.addSupervisor.supervisor_app_year = this.period_supervisor.period_sedirector_year;
      this.addSupervisor.supervisor_app_time = this.period_supervisor.period_sedirector_times;
      this.addSupervisor.supervisor_app_idcard = this.users.id_card;
      this.addSupervisor.supervisor_app_idref = this.supervisor_app_idref;
      this.addSupervisor.supervisor_app_college = this.users.college_code;
      this.addSupervisor.supervisor_app_status = "1";
      this.addSupervisor.supervisor_app_ptype = "3";

      Swal.fire({
        title: "สร้างใบสมัครชั่วคราว",
        text: "ตำแหน่งศึกษานิเทศก์",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b3151b",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      }).then(async result => {
        if (result.isConfirmed) {
          let resultins = await this.$http.post(
            "supervisor_app.insert.php",
            this.addSupervisor
          );
          if (resultins.data.status == true) {
            Swal.fire({
              title: "ดำเนินการข้อมูลเรียบร้อย",
              icon: "success",
              showConfirmButton: false,
              timer: 1500
            });
            await this.supervisorAppQuery();
          } else {
            Swal.fire({
              icon: "warning",
              title: "ข้อมูลอาจซ้ำหรือผิดพลาด กรุณาลองอีกครั้ง",
              showConfirmButton: false,
              timer: 1500
            });
          }
        }
      });
    },

    async supervisorAppSubmit(step) {
      this.supervisor_app.ApiKey = this.ApiKey;
      this.supervisor_app.supervisor_app_year = this.period_supervisor.period_sedirector_year;
      this.supervisor_app.supervisor_app_time = this.period_supervisor.period_sedirector_times;
      this.supervisor_app.supervisor_app_idcard = this.users.id_card;
      this.supervisor_app.supervisor_app_agework = this.get_gov_Age;
      this.supervisor_app.supervisor_age_position = this.get_Appoint_Age;
      this.supervisor_app.supervisor_app_status = step;

      let resultup = await this.$http.post(
        "supervisor_app.update.php",
        this.supervisor_app
      );
      if (resultup.data.status == true) {
        Swal.fire({
          title: "ดำเนินการข้อมูลเรียบร้อย",
          icon: "success",
          showConfirmButton: false,
          timer: 1500
        });
        await this.supervisorAppQuery();
      } else {
        Swal.fire({
          icon: "warning",
          title: "ผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
    },

    async deleteSupervisorSubmit() {
      Swal.fire({
        title: "ยกเลิกรายการเริ่มต้นใหม่",
        text: "ขั้นตอนนี้เป็นขั้นตอนยกเลิกการสมัคร",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b3151b",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      }).then(async result => {
        if (result.isConfirmed) {
          this.supervisor_app.ApiKey = this.ApiKey;
          let result = await this.$http.post(
            "supervisor_app.delete.php",
            this.supervisor_app
          );
          if (result.data.status == true) {
            Swal.fire({
              title: "ดำเนินการข้อมูลเรียบร้อย",
              icon: "success",
              showConfirmButton: false,
              timer: 1500
            });
            await this.supervisorAppQuery();
          } else {
            Swal.fire({
              icon: "warning",
              title: "ผิดพลาด",
              showConfirmButton: false,
              timer: 1500
            });
          }
        }
      });
    },

    async autoSaveChecklist() {
      this.supervisor_app.ApiKey = this.ApiKey;
      await this.$http.post("supervisor_app.update.php", this.supervisor_app);
    },

    async confirmSupervisorAppSubmit() {
      Swal.fire({
        title: "ยืนยันการสมัคร",
        text:
          "เมื่อยืนยันแล้วจะไม่สามารถกลับมาแก้ไขข้อมูลได้อีก ท่านต้องการยืนยันใช่หรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b3151b",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      }).then(async result => {
        if (result.isConfirmed) {
          await this.sweetAlertLoading();

          this.supervisor_app.ApiKey = this.ApiKey;
          this.supervisor_app.supervisor_app_status = 7;
          let dateTime = String(new Date());
          this.supervisor_app.supervisor_app_datetime = dateTime;

          let resultup = await this.$http.post(
            "supervisor_app.update.php",
            this.supervisor_app
          );

          Swal.close();

          if (resultup.data.status == true) {
            Swal.fire({
              title: "ยืนยันการสมัครเรียบร้อย",
              icon: "success",
              showConfirmButton: false,
              timer: 1500
            });
            await this.supervisorAppQuery();
          } else {
            Swal.fire({
              icon: "warning",
              title: "ผิดพลาดในการบันทึกข้อมูล",
              showConfirmButton: false,
              timer: 1500
            });
          }
        }
      });
    },

    calculateAge(startDateStr, endDateStr) {
      let startDate = new Date(startDateStr);
      let endDate = new Date(endDateStr);
      if (isNaN(startDate) || isNaN(endDate)) return "ไม่สามารถคำนวณได้";
      if (startDate > endDate) [startDate, endDate] = [endDate, startDate];

      const startYear = startDate.getFullYear();
      const february =
        (startYear % 4 === 0 && startYear % 100 !== 0) || startYear % 400 === 0
          ? 29
          : 28;
      const daysInMonth = [
        31,
        february,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
      ];

      let yearDiff = endDate.getFullYear() - startYear;
      let monthDiff = endDate.getMonth() - startDate.getMonth();
      let dayDiff = endDate.getDate() - startDate.getDate();

      if (monthDiff < 0) {
        yearDiff--;
        monthDiff += 12;
      }
      if (dayDiff < 0) {
        if (monthDiff > 0) {
          monthDiff--;
        } else {
          yearDiff--;
          monthDiff = 11;
        }
        dayDiff += daysInMonth[startDate.getMonth()];
      }
      return yearDiff + " ปี " + monthDiff + " เดือน " + dayDiff + " วัน";
    },

    async sweetAlertLoading() {
      Swal.fire({
        title: "Please Wait !",
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
    }
  },

  computed: {
    supervisor_app_idref() {
      return (
        (this.users.id_card || "") +
        (this.period_supervisor.period_sedirector_year || "") +
        (this.period_supervisor.period_sedirector_times || "")
      );
    },

    time_stamp() {
      return Math.floor(new Date().getTime() / 1000);
    },

    get_gov_Age() {
      let yearsApp = parseInt(this.users.appoin_year) - 543;
      let dateTimeApp =
        yearsApp + "-" + this.users.appoin_month + "-" + this.users.appoin_day;
      return this.calculateAge(
        dateTimeApp,
        this.period_supervisor.period_sedirector_dmycal
      );
    },

    get_Appoint_Age() {
      return this.calculateAge(
        this.users.date_app_positonnow,
        this.period_supervisor.period_sedirector_dmycal
      );
    },

    get_PrevPosition_Age() {
      if (
        !this.supervisor_app.supervisor_app_prev_start ||
        !this.supervisor_app.supervisor_app_prev_end
      )
        return "";
      return this.calculateAge(
        this.supervisor_app.supervisor_app_prev_start,
        this.supervisor_app.supervisor_app_prev_end
      );
    },

    allRequiredFilesChecked() {
      for (let doc of this.documentList) {
        if (doc.required && this.supervisor_app[doc.field] !== "1") {
          return false;
        }
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.bold16 {
  font-size: 16pt;
  font-weight: bold;
}
.bold14 {
  font-size: 14pt;
  font-weight: bold;
}
.normal16 {
  font-size: 16pt;
}
.normal14 {
  font-size: 14pt;
}
</style>